import { SimpleEventHandler } from "@ciaopeople/cp-shatsu/EventHandler";
import { PostMessageProxyPromise } from "@ciaopeople/cp-shatsu/RemoteService";
import { CookieChangeEventData, COOKIE_CHG_EVENT, isCookieChangeEventData, SessionStorageInterface } from "../SessionStorageInterface.js";
import { StorableSession } from "../StorableSession.js";

export class SessionStorageRemoteImpl extends SimpleEventHandler implements SessionStorageInterface {

    constructor(private proxy: PostMessageProxyPromise) {
        super();
        this.proxy.register("SS." + COOKIE_CHG_EVENT, (data: any) => {
            if(isCookieChangeEventData(data)) this.trigger(COOKIE_CHG_EVENT, data);
            return Promise.resolve();
        });
    }
    getFacebookLoginToken(): Promise<string> {
        return this.proxy.invoke("getFacebookLoginToken");
    }
    setFacebookLoginToken(tk: string): Promise<void> {
        return this.proxy.invoke("setFacebookLoginToken");
    }
    onCookieChange(f: (cookieChangeEvent: CookieChangeEventData) => void): void {
        this.on(COOKIE_CHG_EVENT, (evt, data) =>  {
            if(isCookieChangeEventData(data)) f(data);
        });
    }
    
    blockAutologinLonger(): Promise<void> {
        return this.proxy.invoke("blockAutologinLonger");
    }
    startCookieMonitoring(cookieName: string): Promise<void> {
        return this.proxy.invoke("startCookieMonitoring", cookieName);
    }
    stopCookieMonitoring(cookieName: string): Promise<void> {
        return this.proxy.invoke("stopCookieMonitoring", cookieName);
    }
    thereWasASession(): Promise<boolean> {
        return this.proxy.invoke("thereWasASession");
    }
    isAutologinLocked(): Promise<boolean> {
        return this.proxy.invoke("isAutologinLocked");
    }
    blockAutologin(): Promise<void> {
        return this.proxy.invoke("blockAutologin");
    }
    unlockAutologin(): Promise<void> {
        return this.proxy.invoke("unlockAutologin");
    }
    getLoginPreviousState(): Promise<string> {
        return this.proxy.invoke("getLoginPreviousState");
    }
    setLoginPreviousState(loggedIn: boolean): Promise<void> {
        return this.proxy.invoke("setLoginPreviousState", loggedIn);
    }
    setLastLoginProvider(provider: string): Promise<void> {
        return this.proxy.invoke("setLastLoginProvider", provider);
    }
    getLastLoginProvider(): Promise<string> {
        return this.proxy.invoke("getLastLoginProvider");
    }
    cancelFacebookLogin(): Promise<void> {
        return this.proxy.invoke("cancelFacebookLogin");
    }
    clearFacebookLoginToken(): Promise<void> {
        return this.proxy.invoke("clearFacebookLoginToken");
    }
    isFacebookTokenClean(): Promise<boolean> {
        return this.proxy.invoke("isFacebookTokenClean");
    }
    cookieVersionStore(): Promise<void> {
        return this.proxy.invoke("cookieVersionStore");
    }
    shouldUpdateCookies(): Promise<boolean> {
        return this.proxy.invoke("shouldUpdateCookies");
    }
    storeSession(session: StorableSession): Promise<void> {
        return this.proxy.invoke("storeSession", session);
    }
    clearSession(): Promise<void> {
        return this.proxy.invoke("clearSession");
    }
    getSession(): Promise<StorableSession> {
        return this.proxy.invoke("getSession");
    }

    storeSessionAndProvider(session: StorableSession, provider: string): Promise<void> {
        return this.proxy.invoke("storeSessionAndProvider", session, provider);
    }
}